import React from 'react'
import { cn } from '@/lib/utils'
import { TestimonialCard, type TestimonialAuthor } from '@/components/ui/testimonial-card'

export interface TestimonialsSectionProps {
  title: string
  description: string
  testimonials: Array<{ author: TestimonialAuthor; text: string; href?: string }>
  className?: string
}

export function TestimonialsSection({ title, description, testimonials, className }: TestimonialsSectionProps) {
  return (
    <section className={cn('bg-background py-12 px-0 text-foreground sm:py-24 md:py-32', className)}>
      <div className="mx-auto flex max-w-[1280px] flex-col items-center gap-4 text-center sm:gap-16">
        <div className="flex flex-col items-center gap-4 px-4 sm:gap-8">
          <h2 className="max-w-[720px] text-3xl font-semibold leading-tight sm:text-5xl sm:leading-tight">{title}</h2>
          <p className="text-md max-w-[600px] font-medium text-muted-foreground sm:text-xl">{description}</p>
        </div>

        <div className="relative flex w-full flex-col items-center justify-center overflow-hidden">
          <div className="group relative w-full overflow-hidden p-2 [--duration:40s] [--gap:1rem]">
            <div className="flex w-max flex-row [gap:var(--gap)] animate-marquee group-hover:[animation-play-state:paused]">
              {[...Array(3)].map((_, setIndex) => (
                testimonials.map((t, i) => <TestimonialCard key={`m1-${setIndex}-${i}`} {...t} />)
              ))}
            </div>
            <div className="pointer-events-none absolute inset-0 -z-10" />
            <div className="absolute top-2 left-2 right-2 flex w-max flex-row [gap:var(--gap)] animate-marquee2 group-hover:[animation-play-state:paused]">
              {[...Array(3)].map((_, setIndex) => (
                testimonials.map((t, i) => <TestimonialCard key={`m2-${setIndex}-${i}`} {...t} />)
              ))}
            </div>
          </div>
          <div className="pointer-events-none absolute inset-y-0 left-0 hidden w-1/3 bg-gradient-to-r from-background sm:block" />
          <div className="pointer-events-none absolute inset-y-0 right-0 hidden w-1/3 bg-gradient-to-l from-background sm:block" />
        </div>
      </div>
    </section>
  )
}

export default TestimonialsSection
